import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import useApi from 'utils/hooks/api/useApi';
import { matchRoute } from 'utils/routes';
import { getUser } from 'redux/reducers/sessionReducer';
import { SALE_TYPES } from 'utils/constants';

const path = id => `external/settings/sales/${id}`;
const useGlobalSalesSettings = (id = SALE_TYPES.POS.id) => {
  const [
    { result: resultGlobalSalesSettings, loading: loadingGlobalSalesSettings, error },
    getScreeningGlobalSalesSettings,
  ] = useApi(path(id), { initialFetch: false });
  const user = useSelector(getUser);
  const history = useHistory();
  const currentRoute = matchRoute(history.location.pathname);

  useEffect(() => {
    if (user) {
      getScreeningGlobalSalesSettings();
    }
  }, [user, getScreeningGlobalSalesSettings, currentRoute]);

  return [{ resultGlobalSalesSettings, loadingGlobalSalesSettings, error }, getScreeningGlobalSalesSettings];
};

export default useGlobalSalesSettings;
